<div class="container m-b-20" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="end" fxLayoutGap="2%">
  <button mat-raised-button color="primary" [routerLink]="['/system', 'roles-and-permissions']">
    <fa-icon icon="check" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Permissions' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="changeUserPassword()">
    <fa-icon icon="cog" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Change Password' | translate }}
  </button>
</div>

<div class="container" fxLayout="column" fxLayoutGap="2%">
  <mat-card>
    <div fxLayout="row wrap" class="content">
      <div fxFlex="50%" class="header">
        {{ 'labels.inputs.Tenant Id' | translate }}
      </div>

      <div fxFlex="50%">
        {{ tenantIdentifier }}
      </div>

      <div fxFlex="50%" class="header">
        {{ 'labels.inputs.User Id' | translate }}
      </div>

      <div fxFlex="50%">
        {{ profileData.userId }}
      </div>

      <div fxFlex="50%" class="header">
        {{ 'labels.inputs.User Name' | translate }}
      </div>

      <div fxFlex="50%">
        {{ profileData.username }}
      </div>

      <div fxFlex="50%" class="header">
        {{ 'labels.inputs.Office' | translate }}
      </div>

      <div fxFlex="50%">
        {{ profileData.officeName }}
      </div>

      <div fxFlex="50%" class="header">
        {{ 'labels.inputs.Status' | translate }}
      </div>

      <div fxFlex="50%">
        {{ profileData.authenticated ? 'Authenticated' : 'Not Authenticated' }}
      </div>

      <div fxFlex="50%" class="header">
        {{ 'labels.inputs.Language' | translate }}
      </div>

      <div fxFlex="50%">
        {{ language }}
      </div>
    </div>
  </mat-card>

  <mat-card>
    <table class="mat-elevation-z1" mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Role' | translate }}</th>
        <td mat-cell *matCellDef="let role">{{ role.name }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Description' | translate }}</th>
        <td mat-cell *matCellDef="let role">{{ role.description }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>
</div>
